<template>
  <div>
    <section-page
      title="Store Name"
      description="This is the name that will appear on the store page above the items that you share with others."
      is-short
    >
      <div class="flex" style="max-width: 800px">
        <form-field-input
          class="flex-grow mr-100"
          v-model="storeForm.shareable_store_name"
          :validation-errors="storeFormValidationErrors.shareable_store_name"
          size=""
        ></form-field-input>
        <button-outlined
          size=""
          @click="updateStoreName"
          :loading="savingStoreName"
          :disabled="savingStoreName"
        >Save Store Name
        </button-outlined>
      </div>
    </section-page>

    <section-page
      title="Shareable Groups"
      description="These are groups of shareable items that share with other users"
    >
      <template v-slot:right>
        <filter-button-add @click="$refs.createShareableGroupModal.open()">
          New Shareable Group
        </filter-button-add>
      </template>

      <table-default :table-data="shareableGroups">
        <b-table-column label="Name" field="label" sortable v-slot="props">
          {{ props.row.label }}
        </b-table-column>

        <b-table-column label="Description" field="description" v-slot="props">
          {{ props.row.description ? props.row.description : '--' }}
        </b-table-column>

        <b-table-column label="# Items" field="items_count" sortable numeric v-slot="props">
          {{ props.row.shared_assets.length }}
        </b-table-column>

        <b-table-column cell-class="action_cell" width="100" v-slot="props">
          <button-link @click="openManageShareableGroupModal(props.row)">Manage</button-link>
        </b-table-column>
      </table-default>

      <modal-container>
        <modal-crud-form
          ref="createShareableGroupModal"
          title="Shareable Groups"
          form-component="shareable-group-form"
          @saved="$refs.shareableGroupsTable.reloadData()"
          @deleted="$refs.shareableGroupsTable.reloadData()"
        ></modal-crud-form>

        <modal-form-edit
          ref="editShareableGroupModal"
          title="Shareable Groups"
          form-component="shareable-group-form"
          @saved="$refs.shareableGroupsTable.reloadData()"
          @deleted="$refs.shareableGroupsTable.reloadData()"
        >
          <shareable-group-edit-modal
            :selected-shareable-group="selectedShareableGroup"
            @saved="$refs.shareableGroupsTable.reloadData()"
          ></shareable-group-edit-modal>
        </modal-form-edit>
      </modal-container>
    </section-page>
  </div>
</template>

<script>
import TablePaginated from "../../components/table/TablePaginated";
import api from "../../api";
import ShareableGroupEditModal from "./components/ShareableGroupEditModal";

export default {
  name: "ShareableStoreTab",
  components: {
    ShareableGroupEditModal,
    TablePaginated,
  },
  data() {
    return {
      savingStoreName: false,
      storeForm: {
        id: null,
        shareable_store_name: "",
      },
      storeFormValidationErrors: {},
      shareableGroups: [],
      selectedShareableGroup: null,
    };
  },
  mounted() {
    this.storeForm = this.$utils.clone(this.$store.state.account.account);

    api.shareableGroups.all().then(response => {
      this.shareableGroups = response.data
    })
  },
  methods: {
    updateStoreName() {
      this.savingStoreName = true;
      return api.accounts.updateShareableStore(this.storeForm, this.storeFormValidationErrors).then(() => {
        this.savingStoreName = false;
        this.$buefy.toast.open({message: "Store Name Updated", type: "is-success"});
      });
    },
    openManageShareableGroupModal(shareableGroup) {
      this.selectedShareableGroup = shareableGroup;
      this.$refs.editShareableGroupModal.open(shareableGroup);
    },
  },
};
</script>
